/**
 * Template registry — placeholder for the future 20-template Website Builder.
 *
 * Adding a new template:
 *   1. Create folder /sites/templates/<id>/<id>Template.jsx
 *   2. Default-export a React component receiving { config }
 *   3. Register it here with metadata (name, preview, badge)
 *
 * The contractor-basic template is the FIRST shipped template (Evolve Drywall pilot).
 */
import ContractorBasicTemplate from './contractor-basic/ContractorBasicTemplate';
import SecurityProTemplate from './security-pro/SecurityProTemplate';

export const TEMPLATE_REGISTRY = {
  'contractor-basic': {
    id: 'contractor-basic',
    name: 'Contractor Basic',
    description: 'Single-page contractor / trade business site with services, gallery, FAQ and estimate form.',
    industries: ['drywall', 'plumbing', 'hvac', 'general_construction', 'bathroom_remodeling'],
    component: ContractorBasicTemplate,
    preview_image: '',
    badge: 'Trade · Local Services',
  },
  'security-pro': {
    id: 'security-pro',
    name: 'Security Pro',
    description: 'Multi-page security guard company site: services, industries, about, careers and quote form. Light + dark theme.',
    industries: ['security'],
    component: SecurityProTemplate,
    preview_image: '',
    badge: 'Security · Premium',
  },
  // Future placeholders (rendered as "coming soon" in the builder):
  'contractor-premium': {
    id: 'contractor-premium',
    name: 'Contractor Premium',
    description: 'Multi-page version of contractor-basic with project case studies and a blog.',
    industries: ['drywall', 'plumbing', 'hvac', 'general_construction'],
    component: null,
    preview_image: '',
    badge: 'Coming soon',
  },
  'service-modern': {
    id: 'service-modern',
    name: 'Service Modern',
    description: 'Light, design-forward layout for premium service businesses.',
    industries: ['hvac', 'general_construction'],
    component: null,
    preview_image: '',
    badge: 'Coming soon',
  },
};

export function getTemplate(templateId) {
  return TEMPLATE_REGISTRY[templateId] || TEMPLATE_REGISTRY['contractor-basic'];
}

export const ACTIVE_TEMPLATE_IDS = Object.values(TEMPLATE_REGISTRY)
  .filter((t) => t.component)
  .map((t) => t.id);

export default TEMPLATE_REGISTRY;
